class Dropdown {
    private menu: HTMLElement;

    constructor(private dropdown: HTMLElement, private button: HTMLElement) {
        this.menu = this.dropdown?.querySelector('.dropdown-menu')!;

        this.button?.addEventListener('click', () => {
            this.dropdown.classList.contains('show') ? this.close() : this.open();
        });
    }

    close() {
        const icon = this.button.querySelector('i');
        this.dropdown.classList.remove('show');
        icon?.classList.remove('fa-xmark');
        icon?.classList.add('fa-bars');

        window.removeEventListener('click', () => {
        });
    }

    open() {
        const icon = this.button.querySelector('i');
        this.dropdown.classList.add('show');
        icon?.classList.remove('fa-bars');
        icon?.classList.add('fa-xmark');

        window.addEventListener('click', (e) => {
            // Check if target isn't in or is Dropdown and isn't in or is Toggle
            if (!this.dropdown.contains(e.target as Node) && e.target !== this.dropdown && !this.button.contains(e.target as Node) && e.target !== this.button) {
                this.close();
            }
        })
    }
}

window.addEventListener('load', () => {
    const toggle = document.querySelector<HTMLElement>('.dropdown-toggle');
    const dropdown = document.querySelector<HTMLElement>('.dropdown');

    if (!toggle || !dropdown) return;

    new Dropdown(dropdown, toggle);
})